// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"fbd3166f","410":"2425d121","656":"02ea2151","801":"56066e43"}[chunkId] + ".chunk.js";
};